import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const AbsenGuru = ({ token }) => {
  const [jadwalGuru, setJadwalGuru] = useState([]);
  const [riwayatAbsen, setRiwayatAbsen] = useState({});
  const [loading, setLoading] = useState(true);
  
  // State Waktu Realtime (Jam:Menit)
  const [currentTime, setCurrentTime] = useState('');

  // SOLUSI UTAMA: Default 'all' agar jadwal TIDAK SEMBUNYI di luar jam KBM!
  const [filterMode, setFilterMode] = useState('all');

  // Deteksi Hari Ini
  const getHariIndoCurrent = () => {
    const days = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];
    const now = new Date();
    const wibDate = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Jakarta' }));
    return days[wibDate.getDay()];
  };

  const today = getHariIndoCurrent();
  const [selectedHari, setSelectedHari] = useState(today === 'Minggu' ? 'Senin' : today);

  // 1. Clock Digital Realtime (Update setiap 10 detik)
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const h = String(now.getHours()).padStart(2, '0');
      const m = String(now.getMinutes()).padStart(2, '0');
      setCurrentTime(`${h}:${m}`);
    };

    updateTime();
    const clockInterval = setInterval(updateTime, 10000);
    return () => clearInterval(clockInterval);
  }, []);

  // 2. Fetch Jadwal & Status Absen
  useEffect(() => {
    fetchData();
  }, [selectedHari]);

  const fetchData = async () => {
    setLoading(true);
    try {
      // Fetch Jadwal Guru Mengajar
      const resJadwal = await axios.get(`/api/guru-jadwal-aktif?hari=${selectedHari}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Fetch Rekap Absen Guru Hari Ini
      const todayIso = new Date().toISOString().split('T')[0];
      const resAbsen = await axios.get('/api/absen-guru', {
        params: { bulan: todayIso.slice(0, 7) },
        headers: { Authorization: `Bearer ${token}` }
      });

      const mapAbsen = {};
      if (Array.isArray(resAbsen.data)) {
        resAbsen.data.forEach((item) => {
          const tglAbsen = item.tanggal ? item.tanggal.split('T')[0] : '';
          if (tglAbsen === todayIso) {
            if (item.jadwal_id) {
              mapAbsen[`${item.guru_id}_${item.jadwal_id}`] = item.status;
            } else {
              mapAbsen[`${item.guru_id}`] = item.status;
            }
          }
        });
      }

      setJadwalGuru(Array.isArray(resJadwal.data) ? resJadwal.data : []);
      setRiwayatAbsen(mapAbsen);
    } catch (err) {
      console.error('Error fetching data guru:', err);
    }
    setLoading(false);
  };

  // Helper Cek Apakah Jam Sekarang di Dalam Rentang Mengajar
  const isJamOngoing = (jamMulaiStr, jamSelesaiStr) => {
    if (!jamMulaiStr || !jamSelesaiStr) return false;
    const jamMulai = jamMulaiStr.slice(0, 5);
    const jamSelesai = jamSelesaiStr.slice(0, 5);
    return currentTime >= jamMulai && currentTime <= jamSelesai;
  };

  // Filter List Jadwal berdasarkan Mode Filter
  const displayedJadwal = jadwalGuru.filter((item) => {
    if (filterMode === 'all') return true;
    return isJamOngoing(item.jam_mulai, item.jam_selesai);
  });

  // Fungsi Absen Satu-Satu Per Sesi Mengajar
  const handleAbsen = async (guru, status) => {
    let keterangan = '-';
    if (status !== 'hadir') {
      const { value: text, isDismissed } = await Swal.fire({
        title: `Keterangan ${status.toUpperCase()}`,
        input: 'text',
        inputPlaceholder: 'Tulis alasan...',
        showCancelButton: true,
        confirmButtonText: 'Simpan',
        cancelButtonText: 'Batal'
      });
      
      if (isDismissed) return;
      if (!text && status !== 'hadir') {
        Swal.fire('Peringatan', 'Keterangan wajib diisi untuk status ini!', 'warning');
        return;
      }
      keterangan = text || '-';
    }

    try {
      await axios.post('/api/absen-guru', {
        guru_id: guru.guru_id,
        jadwal_id: guru.jadwal_id,
        status: status,
        keterangan: keterangan
      }, { headers: { Authorization: `Bearer ${token}` } });

      const uniqueKey = `${guru.guru_id}_${guru.jadwal_id}`;
      setRiwayatAbsen((prev) => ({
        ...prev,
        [uniqueKey]: status
      }));

      Swal.fire({
        icon: 'success',
        title: 'Berhasil',
        text: `${guru.nama_guru} (${guru.nama_kelas}) tercatat: ${status.toUpperCase()}`,
        timer: 1500,
        showConfirmButton: false
      });
    } catch (err) {
      Swal.fire('Gagal', 'Terjadi kesalahan saat menyimpan.', 'error');
    }
  };

  return (
    <div style={{ paddingBottom: '50px' }}>
      
      {/* HEADER & FILTER */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '15px' }}>
        <div>
          <h2 style={{ color: '#1e293b', margin: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
            📝 Absensi Guru Piket
            {currentTime && (
              <span style={{ fontSize: '13px', background: '#2563eb', color: 'white', padding: '3px 10px', borderRadius: '20px', fontWeight: 'bold' }}>
                🕒 {currentTime} WIB
              </span>
            )}
          </h2>
          <p style={{ margin: '5px 0 0', color: '#64748b' }}>Absen guru berdasarkan jadwal mengajar hari ini.</p>
        </div>

        {/* CONTROLLER TOGGLE FILTER & HARIAN */}
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
          
          {/* TOGGLE FILTER JAM */}
          <div style={{ background: '#e2e8f0', padding: '4px', borderRadius: '8px', display: 'flex', gap: '4px' }}>
            <button
              onClick={() => setFilterMode('ongoing')}
              style={{
                padding: '6px 14px',
                borderRadius: '6px',
                border: 'none',
                background: filterMode === 'ongoing' ? '#2563eb' : 'transparent',
                color: filterMode === 'ongoing' ? 'white' : '#475569',
                fontWeight: 'bold',
                fontSize: '13px',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
            >
              🔥 Jam Sekarang
            </button>
            <button
              onClick={() => setFilterMode('all')}
              style={{
                padding: '6px 14px',
                borderRadius: '6px',
                border: 'none',
                background: filterMode === 'all' ? '#2563eb' : 'transparent',
                color: filterMode === 'all' ? 'white' : '#475569',
                fontWeight: 'bold',
                fontSize: '13px',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
            >
              📋 Semua Jam
            </button>
          </div>

          {/* DROPDOWN HARI */}
          <div style={{ background: 'white', padding: '8px 12px', borderRadius: '10px', boxShadow: '0 2px 5px rgba(0,0,0,0.05)', display: 'flex', alignItems: 'center' }}>
            <span style={{ fontWeight: 'bold', color: '#334155', marginRight: '10px' }}>Hari:</span>
            <select 
              value={selectedHari} 
              onChange={(e) => setSelectedHari(e.target.value)} 
              style={{ padding: '6px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', fontWeight: 'bold' }}
            >
              {['Senin','Selasa','Rabu','Kamis','Jumat','Sabtu'].map(h => <option key={h} value={h}>{h}</option>)}
            </select>
          </div>

        </div>
      </div>

      {/* LIST GURU PER JADWAL */}
      {loading ? (
        <p style={{ textAlign: 'center', color: '#64748b', padding: '40px' }}>Memuat jadwal guru...</p>
      ) : (
        <div style={{ display: 'grid', gap: '15px' }}>
          {displayedJadwal.length === 0 ? (
            <div style={{ textAlign: 'center', color: '#64748b', padding: '40px', background: 'white', borderRadius: '12px', border: '1px dashed #cbd5e1' }}>
              ☕ <b>{filterMode === 'ongoing' ? `Tidak ada jadwal guru mengajar pada jam ${currentTime}.` : 'Tidak ada jadwal mengajar pada hari ini.'}</b>
              <p style={{ margin: '5px 0 0', fontSize: '13px' }}>
                {filterMode === 'ongoing' && 'Gunakan tombol "📋 Semua Jam" di atas untuk melihat seluruh jadwal hari ini.'}
              </p>
            </div>
          ) : (
            displayedJadwal.map((g, idx) => {
              const uniqueKey = `${g.guru_id}_${g.jadwal_id}`;
              const statusAbsen = riwayatAbsen[uniqueKey] || riwayatAbsen[g.guru_id];
              const sudahDiabsen = Boolean(statusAbsen);

              return (
                <div 
                  key={uniqueKey || idx} 
                  style={{ 
                    background: sudahDiabsen ? '#f0fdf4' : 'white', 
                    padding: '20px', 
                    borderRadius: '12px', 
                    boxShadow: '0 4px 6px rgba(0,0,0,0.05)', 
                    border: sudahDiabsen ? '1.5px solid #86efac' : '1px solid #e2e8f0',
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'space-between', 
                    flexWrap: 'wrap', 
                    gap: '15px',
                    transition: 'all 0.2s'
                  }}
                >
                  
                  {/* Info Guru & Jadwal */}
                  <div style={{ flex: 1, minWidth: '250px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                      <div style={{ width: '50px', height: '50px', background: '#e0e7ff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', color:'#4361ee' }}>👨‍🏫</div>
                      <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <h3 style={{ margin: 0, fontSize: '16px', color: '#1e293b' }}>{g.nama_guru}</h3>
                          {sudahDiabsen && (
                            <span style={{ fontSize: '11px', background: '#dcfce7', color: '#15803d', padding: '2px 8px', borderRadius: '12px', fontWeight: 'bold' }}>
                              ✓ Terabsen ({statusAbsen.toUpperCase()})
                            </span>
                          )}
                        </div>
                        <div style={{ fontSize: '12px', color: '#64748b', marginTop: '4px' }}>
                          <span style={{ background: '#f1f5f9', padding: '3px 8px', borderRadius: '4px', fontWeight: 'bold', marginRight: '8px' }}>
                            {g.jam_mulai ? g.jam_mulai.slice(0,5) : '00:00'} - {g.jam_selesai ? g.jam_selesai.slice(0,5) : '00:00'}
                          </span>
                          <span style={{ background: '#dbeafe', color: '#1e40af', padding: '3px 8px', borderRadius: '4px', fontWeight: 'bold' }}>
                            {g.nama_kelas}
                          </span>
                        </div>
                        <div style={{ fontSize: '12px', color: '#334155', marginTop: '4px', fontWeight: '500' }}>{g.mapel}</div>
                      </div>
                    </div>
                  </div>

                  {/* Tombol Aksi */}
                  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    {[
                      { key: 'hadir', label: 'Hadir', bg: '#10b981' },
                      { key: 'telat', label: 'Telat', bg: '#f59e0b' },
                      { key: 'izin', label: 'Izin', bg: '#3b82f6' },
                      { key: 'sakit', label: 'Sakit', bg: '#8b5cf6' },
                      { key: 'alfa', label: 'Alfa', bg: '#ef4444' }
                    ].map((btn) => {
                      const isSelected = statusAbsen === btn.key;
                      return (
                        <button 
                          key={btn.key}
                          onClick={() => handleAbsen(g, btn.key)} 
                          style={{ 
                            padding: '8px 15px', 
                            background: isSelected ? btn.bg : '#f1f5f9', 
                            color: isSelected ? 'white' : '#64748b', 
                            border: 'none', 
                            borderRadius: '6px', 
                            fontWeight: 'bold', 
                            cursor: 'pointer',
                            opacity: (statusAbsen && !isSelected) ? 0.45 : 1,
                            transition: 'all 0.2s',
                            boxShadow: isSelected ? '0 2px 4px rgba(0,0,0,0.15)' : 'none'
                          }}
                        >
                          {isSelected ? `✓ ${btn.label}` : btn.label}
                        </button>
                      );
                    })}
                  </div>

                </div>
              );
            })
          )}
        </div>
      )}
    </div>
  );
};

export default AbsenGuru;